// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiRepContributorsPage } from '../models/ApiRepContributorsPage';
import { HttpFile } from '../http/http';

export class ApiRepOverview {
    'total_rep': number;
    'authenticated_user_contribution': number | null;
    'contributor_count': number;
    'contributors': ApiRepContributorsPage;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "total_rep",
            "baseName": "total_rep",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "authenticated_user_contribution",
            "baseName": "authenticated_user_contribution",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "contributor_count",
            "baseName": "contributor_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "contributors",
            "baseName": "contributors",
            "type": "ApiRepContributorsPage",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiRepOverview.attributeTypeMap;
    }

    public constructor() {
    }
}

